
define('css!ui/generis/widget/widget',[],function(){});
